import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-text',
    templateUrl: './icon-text.component.html',
    styleUrls: ['./icon-text.component.scss'],
})
export class IconTextComponent {
    @Input() iconName: string = '';
    @Input() iconOutlined: string = 'true';
    @Input() inputText: string = '';
    @Input() active = false;
}
